import { render } from "./BookingSlot.vue?vue&type=template&id=5d73fc77"
import script from "./BookingSlot.vue?vue&type=script&lang=js"
export * from "./BookingSlot.vue?vue&type=script&lang=js"

import "./BookingSlot.vue?vue&type=style&index=0&lang=css"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "5d73fc77"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d73fc77', script)) {
    api.reload('5d73fc77', script)
  }
  
  module.hot.accept("./BookingSlot.vue?vue&type=template&id=5d73fc77", () => {
    api.rerender('5d73fc77', render)
  })

}

script.__file = "src/components/BookingSlot.vue"

export default script